module.exports = __webpack_public_path__ + "static/media/online-reserv.8a93ea93.png";